import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { AnalyticsState, AnalyticsFiltersData } from "./types";

export const analyticsInitialState: AnalyticsState = {
  dateRanges: [],
  productTypes: [],
  strains: [],
  defaults: null,
};

const AnalyticsModuleSlice = createSlice({
  name: "analytics",
  initialState: analyticsInitialState,
  reducers: {
    setAnalyticsFilters: (
      state,
      action: PayloadAction<AnalyticsFiltersData>,
    ) => {
      state.dateRanges = action.payload.dateRanges || [];
      state.productTypes = action.payload.productTypes || [];
      state.strains = action.payload.strains || [];
      state.defaults = action.payload.defaults || null;
    },
  },
});

export const { setAnalyticsFilters } = AnalyticsModuleSlice.actions;

export default AnalyticsModuleSlice.reducer;
